module.exports = __webpack_public_path__ + "img/marker_alignment.d0df5929.png";